import React, {useState, useRef} from 'react'
import {Icon, Input, Spin, Modal, Button, message} from "antd"
import {markBatchPackaged, listBatchesV4} from '../../../services/api/3dApi'
import {NavLink} from 'react-router-dom'
import moment from 'moment'

function MarkPackagedPage() {
    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [history, setHistory] = useState([])
    const [errorInput, setErrorInput] = useState('')
    const [batch, setBatch] = useState('')
    const [countHistory, setCountHistory] = useState(0)
    const getBatch = async (name) => {
        const {data: response} = await listBatchesV4({name})
        const {data, message, success} = response
        const {batches = []} = {...data}

        if (!batches.length || !success) {
            addHistory({
                name,
                packageStatus: 'error',
                packageMessage: message || 'Không tìm thấy tên lô',
            })
            return Modal.error({
                title: 'Lỗi',
                content: message || 'Không tìm thấy tên lô',
                //onOk: _resetScanInput(),
                okText: 'Đóng',
            })
        }

        const [batch] = batches

        // if (batch.status !== 'completed') {
        //     const msg = `Chỉ đánh dấu đóng gói lô khi đã {completed}. Trạng thái hiện tại {${batch.status}}`
        //     addHistory({
        //         name,
        //         packageStatus: 'error',
        //         packageMessage: msg,
        //     })
        //     return Modal.error({
        //         title: 'Lỗi',
        //         content: msg,
        //         //onOk: _resetScanInput(),
        //         okText: 'Đóng',
        //     })
        // }

        if (batch.packaged) {
            const {user, date} = {...batch.packaged}
            const msg = `Lô đã được đánh dấu đóng gói bởi ${user} lúc ${moment(date).format('HH:mm DD/MM/YYYY')}`
            addHistory({
                name,
                packageStatus: 'error',
                packageMessage: msg,
            })
            return Modal.error({
                title: 'Lỗi',
                content: msg,
                //onOk: _resetScanInput(),
                okText: 'Đóng',
            })
        }

        batch.packageStatus = 'ready'
        batch.packageMessage = `Chờ đánh dấu đóng gói với ${batch.items_completed_count} items...`
        batch.uniId = Date.now()
        setBatch(batch)
        addHistory(batch)
    }

    const addHistory = (h) => {
        setHistory([{...h, ...(!h.uniId && {uniId: Date.now()})}])
        setCountHistory(countHistory + 1)
    }

    const replaceHistory = (h) => {
        const replace = history.map(it => {
            if (h.uniId && it.uniId === h.uniId) {
                return {
                    ...it,
                    ...h,
                }
            }

            return it
        })

        setHistory(replace)
    }

    const mark = async () => {
        setLoading(true)
        try {
            const response = await markBatchPackaged(batch._id)
            const {data: newBatch} = response
            message.success(`Đánh dấu đóng gói lô ${batch.name} thành công!`)
            replaceHistory({
                ...batch,
                ...newBatch,
            })
        } catch (e) {
            message.success(e.message)
            replaceHistory({
                ...batch,
                packageMessage: e.message,
                packageStatus: 'error',
            })
        }
        _resetScanInput()
        setLoading(false)
        setBatch('')
    }

    const _onSubmit = async (e) => {
        e.preventDefault()

        if (!valueInput || !`${valueInput}`.length) {
            return setErrorInput('Nhập vào mã lô.')
        }

        const [lastHistory] = history || []

        if (lastHistory && lastHistory.name === valueInput) {
            if (batch) {
                batch.packageStatus === 'ready' && await mark()

                _resetScanInput()
                return false
            }

            if (lastHistory.packageStatus === 'success') {
                setErrorInput('Lô đã được đánh dấu đóng gói')

                _resetScanInput()
                return false
            }
        }

        setLoading(true)
        setBatch('')

        const checkValue = /^\w+-\d/.test(valueInput)

        if (!checkValue || !valueInput.trim()) {
            const msg = 'Mã lô sai định dạng'
            setErrorInput(msg)
            setLoading(false)
            addHistory({
                name: valueInput,
                packageStatus: 'error',
                packageMessage: msg,
            })
            return false
        }

        try {
            await getBatch(valueInput)
        } catch (error) {
            setErrorInput(error)
            addHistory({
                name: valueInput,
                packageStatus: 'error',
                packageMessage: error,
            })
        } finally {
            setLoading(false)
        }
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const handleMarkPackaged = async () => {
        setLoading(true)

        try {
            await mark()
        } catch (error) {
            setErrorInput(error)
            addHistory({
                name: valueInput,
                packageStatus: 'error',
                packageMessage: error,
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="MarkPackagedPage py-5">
            <div className="col-12 mx-auto px-5">
                <div className="d-flex align-items-baseline justify-content-between">
                    <h1 className="PageTitle">Đánh dấu đóng gói</h1>
                    <label className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6">
                        <NavLink exact to="/batches/packing/list" className="nav-link p-0">
                            Danh sách đóng gói
                        </NavLink>
                    </label>
                </div>
                <div className="site-layout-background pb-4">
                    <div className="UpdateBatchPackaged">
                        <div className="UpdateBatchPackagedPage">
                            <div className="position-relative">
                                <Spin spinning={loading} tip="Đang kiểm tra...">
                                    <form onSubmit={_onSubmit} className="mb-4">
                                        <Input
                                            value={valueInput.toUpperCase()}
                                            style={{fontSize: 40, height: "auto"}}
                                            ref={_input}
                                            autoFocus={true}
                                            placeholder="Nhập vào tên lô"
                                            onChange={_handleChangeScan}
                                        />

                                        {
                                            valueInput &&
                                            <Icon
                                                type="close-circle"
                                                className="position-absolute cursor-pointer text-dark IconInput"
                                                onClick={_resetScanInput}
                                            />
                                        }

                                        {
                                            loading &&
                                            <Icon type="sync" spin className="position-absolute IconInput"/>
                                        }

                                        {
                                            (!loading) && batch &&
                                            <Button
                                                type="primary"
                                                className="float-right mt-3 px-4"
                                                onClick={handleMarkPackaged}
                                            >
                                                Đóng gói
                                            </Button>
                                        }
                                    </form>

                                    {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                                    {
                                        history && !!history.length && <table className="recent-history">
                                            <tbody>
                                            {
                                                history.map((h, index) => {
                                                    return <tr key={`${h.uniId}_${h.name}`}
                                                               className={h.packageStatus}>
                                                        {/*<td className="text-right pr-2">{countHistory - index}</td>*/}
                                                        <td><span className="ant-tag ant-tag-has-color">{h.name}</span>
                                                        </td>
                                                        <td><span className="text-muted">{h.packageMessage}</span></td>
                                                    </tr>
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    }
                                </Spin>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default MarkPackagedPage